<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nr5f83/tc-custom/9781467443869.jpg?1726871225896" alt="This image is the cover for the book Discovering John, Discovering Biblical Texts (DBT)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Discovering John, Discovering Biblical Texts (DBT)
      </h1>
      <p class="bookDescription body article font2">
        <i>Student-friendly introduction to the Gospel of John</i><br/><br/> This up-to-date introduction to John's Gospel is the first volume in the Discovering Biblical Texts series, which encourages students to engage deeply with the biblical writings by alerting them to key issues and questions raised by the text.<br/><br/> In <i>Discovering John</i> Ruth Edwards covers the structure, content, theological concerns, key interpretive debates, and historical reception of the Gospel of John. Does John still have meaning for the church and contemporary society? Does it need to be reinterpreted for today's world? Is it anti-Semitic? Edwards expertly guides readers through these questions and others, helping those interested in this provocative, sometimes enigmatic Gospel to discover the answers for themselves.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ruth B. Edwards
      </h2>
      
      <p class="authorDescription body article">Ruth B. Edwards is an honorary senior lecturer at the University of Aberdeen and a priest of the Scottish Episcopal Church.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8794da9e